
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estimation/map",
      function () {
        return require("private-next-pages/estimation/map/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estimation/map"])
      });
    }
  